import { Component, OnInit, Input } from '@angular/core';
import { StatService } from '../../services/stat.service';

@Component({
  selector: 'stat-selector',
  templateUrl: './stat.component.html'
})
export class StatComponent implements OnInit {
  @Input() type;
  @Input() ngModel;
  @Input() options;

  constructor(
    private statService: StatService
  ) { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/components/stat/stat.component.ts